import React from 'react'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import {
  ATLAtomIcon,
  ATLTextHead,
  TextAlignmentEnum,
  ATLSpacing,
  SpacingSizesEnum,
  ATLTextBody,
} from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { FlatList, ImageSourcePropType, TouchableOpacity, Animated } from 'react-native'
import { Colors } from '../../constants/colors'
import { screenHeight, screenWidth } from '../../constants/dimensions'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'

export interface DashboardCustomDropdownItem {
  id: number | string
  text: string
  icon?: ImageSourcePropType
}

interface DashboardCustomDropdownListProps {
  data: DashboardCustomDropdownItem[]
  handleClick: () => void
  height: Animated.Value | number
  onSelect: (item: DashboardCustomDropdownItem) => void
}

const ListContainer = styled.SafeAreaView`
  position: absolute;
  bottom: 0px;
  z-index: 3;
  opacity: 1;
  background-color: ${atlTheme.ColorSurface};
  width: 100%;
  padding-top: ${atlTheme.SpacingMarginal}px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`
const Container = styled.TouchableOpacity`
  width: ${screenWidth}px;
  height: ${screenHeight}px;
  opacity: 0.5;
  position: absolute;
  z-index: 2;
  background-color: ${Colors.black};
`
const ListHeader = styled.View`
  flex-direction: row;
`
const ListHeaderTitleContainer = styled.View`
  width: 90%;
`

export const DashboardCustomDropdownList: React.FC<DashboardCustomDropdownListProps> = ({
  handleClick,
  height,
  onSelect,
  data,
}) => {
  const renderItem = (item: DashboardCustomDropdownItem) => {
    return (
      <TouchableOpacity onPress={() => onSelect(item)}>
        <ATLTextBody labelBaseProps={{ multilineLimit: 1, textColor: atlTheme.ColorBrand1Default }}>
          {item?.text?.toUpperCase()}
        </ATLTextBody>
      </TouchableOpacity>
    )
  }

  return (
    <>
      <Container onPress={handleClick} />
      <ListContainer>
        <Animated.View style={[{ height: height }]}>
          <ListHeader>
            <ListHeaderTitleContainer>
              <ATLTextHead
                textAlignment={TextAlignmentEnum.left}
                labelBaseProps={{
                  fontSize: atlTheme.FontSizeHeading,
                  fontWeight: atlTheme.FontWeight500,
                }}
              >
                {formatMessage(messages.dashboard_dropdownHeaderTitle)}
              </ATLTextHead>
            </ListHeaderTitleContainer>
            <TouchableOpacity style={{ marginTop: atlTheme.SpacingAtomic }} onPress={handleClick}>
              <ATLAtomIcon source={icons.close} />
            </TouchableOpacity>
          </ListHeader>
          <FlatList data={data} keyExtractor={item => item.id.toString()} renderItem={({ item }) => renderItem(item)} />
          <ATLSpacing type={SpacingSizesEnum.marginal} />
        </Animated.View>
      </ListContainer>
    </>
  )
}
